import { ReactElement, useContext, useEffect } from 'react';
import { ctxUser } from '../../contexts/UserContext';
import StreamChatLayer from '@/components/stream-chat/StreamChatLayer';
import StreamChatPhoneLayer from './StreamChatPhoneLayer';
import { getChatUserIdV2 } from '@/generated/client/chat/chat';
import { chatContext } from '@/contexts/ChatContext';
import { useState } from 'react';
import { isRunningInApp } from '@/utilities/sizeUtils';

export function StreamChatAccess({ children }: { children: ReactElement }) {
  const userCtx = useContext(ctxUser);
  const [chatId, setChatId] = useState<string | undefined>();

  useEffect(() => {
    async function setChatUserId() {
      const userId = (await getChatUserIdV2()).data.userId;
      setChatId(userId);
    }
    void setChatUserId();
  }, []);

  if (!userCtx || !chatId) {
    return children;
  }
  const username = userCtx.user.name;

  if (isRunningInApp()) {
    return (
      <chatContext.Provider value={{ chatId, setChatId }}>
        <StreamChatPhoneLayer userId={chatId} userName={username}>
          {children}
        </StreamChatPhoneLayer>
      </chatContext.Provider>
    );
  }
  return (
    <chatContext.Provider value={{ chatId, setChatId }}>
      <StreamChatLayer userId={chatId} userName={username}>
        {children}
      </StreamChatLayer>
    </chatContext.Provider>
  );
}
